export const basiclessons: any[]= [
    { id:'21',name: 'Artes' },
    { id:'15',name: 'Ciencias Naturales' },
    { id:'616',name: 'Educación Fisica / Psicomotricidad' },
    { id:'16',name: 'Ciencias Sociales' },
    { id:'24',name: 'Lenguaje y Comunicación' },
    { id:'28',name: 'Matemáticas' },
    { id:'30',name: 'Música' },
    { id:'35',name: 'Orientación' },
    { id:'29',name: 'Tecnología' },
    { id:'177',name: 'Inglés' },
    { id:'549',name: 'Derecho Básico de Aprendizaje - Ciencias' },
    { id:'548',name: 'Derecho Básico de Aprendizaje - Matemáticas' },
    { id:'547',name: 'Derecho Básico de Aprendizaje - Lenguaje' }   
  ];